import { useQuery } from '@tanstack/react-query'

import { DefaultApiGetGuaranteeMoneyBalanceInformationForOrganizationRequest } from '@src/api/generated/user-api'
import { getGuaranteeMoneyBalanceInformationForOrganization } from '@src/api/repositories'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchGuaranteeMoneyBalance = (
  params: DefaultApiGetGuaranteeMoneyBalanceInformationForOrganizationRequest
) => {
  const { axiosInstance } = useAxios()
  const { organizationId, ...queryParameter } = params

  return useQuery({
    enabled: !!organizationId,
    queryFn: () =>
      getGuaranteeMoneyBalanceInformationForOrganization(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_GUARANTEE_MONEY_BALANCE_INFORMATION_FOR_ORGANIZATION,
      params.organizationId,
      queryParameter,
    ],
  })
}
